import { c as _c } from "react/compiler-runtime";
import Icon from '../base/Icon';
import { StyledCard } from '../base/Card';
import Text from '../base/Text';
import Tooltip from '../base/Tooltip';
import type { TooltipCTA } from '../base/Tooltip';
import BarChart from '../Chart/BarChart';
import { ChartDataSet, ChartTimeOptions } from '../Chart/Chart';
import LineChart from '../Chart/LineChart';
import NoDataChart from '../Chart/NoDataChart';
import { Div } from '../helpers/StyledUtils';
const default_height = 316;
interface MetricChartProps {
  chart_type: 'bar' | 'line';
  datasets: ChartDataSet[] | null;
  datasets_type?: 'stacked' | 'switch';
  title: string;
  title_tooltip?: React.ReactNode;
  title_tooltip_cta?: TooltipCTA;
  legend_placeholder?: string;
  force_legend?: boolean;
  total?: number | string;
  total_hint?: string;
  height?: number;
  loading?: boolean;
  error?: boolean;
  action?: React.ReactNode;
  time_options?: ChartTimeOptions;
  time_label?: React.ReactNode;
}
const MetricChart: React.FC<MetricChartProps> = t0 => {
  const $ = _c(32);
  const {
    chart_type,
    datasets,
    datasets_type,
    title,
    title_tooltip,
    title_tooltip_cta,
    legend_placeholder,
    force_legend,
    total,
    total_hint,
    height: t1,
    loading,
    error,
    action,
    time_options,
    time_label
  } = t0;
  const height = t1 === undefined ? default_height : t1;
  const has_data = datasets?.some(_temp2);
  const show_no_data = !loading && (error || !has_data);
  if (show_no_data) {
    const title_height = title ? 40 : 0;
    let t2;
    if ($[0] !== height) {
      t2 = {
        px: height
      };
      $[0] = height;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        direction: "column"
      };
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== title || $[4] !== title_tooltip || $[5] !== title_tooltip_cta) {
      t4 = title && <Div p={{
        x: 4,
        t: 4
      }} flex={{
        align: "center",
        gap: 1
      }}><Text semi={true}>{title}</Text>{title_tooltip && <Tooltip tooltip={title_tooltip} cta={title_tooltip_cta}><Icon muted={true} icon="info" /></Tooltip>}</Div>;
      $[3] = title;
      $[4] = title_tooltip;
      $[5] = title_tooltip_cta;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    const t5 = height - title_height - 16;
    let t6;
    if ($[7] !== t5) {
      t6 = <NoDataChart height={t5} />;
      $[7] = t5;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    let t7;
    if ($[9] !== t2 || $[10] !== t4 || $[11] !== t6) {
      t7 = <StyledCard h={t2} flex={t3}>{t4}{t6}</StyledCard>;
      $[9] = t2;
      $[10] = t4;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    return t7;
  }
  let t2;
  if ($[13] !== action || $[14] !== datasets || $[15] !== force_legend || $[16] !== height || $[17] !== legend_placeholder || $[18] !== loading || $[19] !== time_label || $[20] !== time_options || $[21] !== title || $[22] !== title_tooltip || $[23] !== title_tooltip_cta || $[24] !== total || $[25] !== total_hint) {
    t2 = {
      title,
      title_tooltip,
      title_tooltip_cta,
      legend_placeholder,
      force_legend,
      datasets,
      total,
      total_hint,
      height,
      loading,
      action,
      time_options,
      time_label
    };
    $[13] = action;
    $[14] = datasets;
    $[15] = force_legend;
    $[16] = height;
    $[17] = legend_placeholder;
    $[18] = loading;
    $[19] = time_label;
    $[20] = time_options;
    $[21] = title;
    $[22] = title_tooltip;
    $[23] = title_tooltip_cta;
    $[24] = total;
    $[25] = total_hint;
    $[26] = t2;
  } else {
    t2 = $[26];
  }
  const chart_props = t2;
  if (chart_type === "line") {
    let t3;
    if ($[27] !== chart_props) {
      t3 = <StyledCard><LineChart {...chart_props} /></StyledCard>;
      $[27] = chart_props;
      $[28] = t3;
    } else {
      t3 = $[28];
    }
    return t3;
  }
  if (chart_type === "bar") {
    let t3;
    if ($[29] !== chart_props || $[30] !== datasets_type) {
      t3 = <StyledCard><BarChart {...chart_props} datasets_type={datasets_type} /></StyledCard>;
      $[29] = chart_props;
      $[30] = datasets_type;
      $[31] = t3;
    } else {
      t3 = $[31];
    }
    return t3;
  }
  return null;
};
export default MetricChart;
function _temp(data) {
  return Number.isFinite(Number(data.y));
}
function _temp2(dataset) {
  return dataset.data.some(_temp);
}